"use client";

import React from "react";
import { BlurFade } from "@/components/ui/blur-fade";

interface HeroMinimalProps {
  title: string;
  category?: string;
  date?: string;
}

const HeroMinimal = ({ title, category, date }: HeroMinimalProps) => {
  return (
    <section className="py-24 md:py-36 px-6 bg-white">
      <div className="container max-w-4xl mx-auto">
        {/* Category / Date metadata */}
        {(category || date) && (
          <BlurFade delay={0.05}>
            <div className="flex items-center gap-3 mb-6 text-sm text-foreground/40 uppercase tracking-widest font-medium">
              {category && <span>{category}</span>}
              {category && date && <span className="text-foreground/20">•</span>}
              {date && <span>{date}</span>}
            </div>
          </BlurFade>
        )}

        {/* Title - editorial serif style */}
        <BlurFade delay={0.1}>
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-serif font-bold tracking-tight text-foreground leading-[1.05]">
            {title}
          </h1>
        </BlurFade>

        {/* Decorative line */}
        <BlurFade delay={0.2}>
          <div className="mt-10 w-16 h-px bg-foreground/20" />
        </BlurFade>
      </div>
    </section>
  );
};

export default HeroMinimal;
